import { QuestionComponentProps } from "..";

import { RemoteLocationSelector } from "./components/RemoteLocationSelector";

export function RemoteLocation({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <RemoteLocationSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
